import storeSettingConfig from './storeSettings/storeSettingConfig'
import aiSettingConfig from './aiSetting/aiSettingConfig'
import responseConfig from './responseMessage/responseConfig'
import shippingConfig from './shipping/shippingConfig'

export default [
  storeSettingConfig,
  aiSettingConfig,
  responseConfig,
  shippingConfig,
]



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/ecommerceConfig.js